// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SectionEdits = function (x) {
    return x;
};
var tsBridgeSectionEdits = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SectionEdits")("__brandSectionEdits"));
    }
};
var writeSectionEdits = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSectionEdits = Data_Show.showString;
var readSectionEdits = Simple_JSON.readString;
var ordSectionEdits = Data_Ord.ordString;
var newtypeSectionEdits = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSectionEdits = SectionEdits;
var eqSectionEdits = Data_Eq.eqString;
export {
    SectionEdits,
    makeSectionEdits,
    unwrap,
    newtypeSectionEdits,
    eqSectionEdits,
    ordSectionEdits,
    showSectionEdits,
    readSectionEdits,
    writeSectionEdits,
    tsBridgeSectionEdits
};
//# sourceMappingURL=index.js.map
